interface PhoneNumberProps {
  additionalClasses: string;
  number: string;
  origin?: string;
}

const PhoneNumber = ({
  additionalClasses = '',
  number,
  origin,
}: PhoneNumberProps) => {
  const withoutSpaces = (num: string) => num.replace(/ /g, '');

  return (
    <a
      className={`ac-phone ch-link ${additionalClasses}`}
      data-gtm-track="click_cta"
      data-gtm-track-label={`Phone number click - (${origin})`}
      href={`tel:${withoutSpaces(number)}`}
    >
      {number}
    </a>
  );
};

PhoneNumber.displayName = 'PhoneNumber';

export default PhoneNumber;
